import { ComputedRef } from 'vue'

import { User } from '@/domain/entities/user/user'
import { DisplayLanguageType } from '@/domain/value_objects/language/displayLanguageType'
import { LanguageStatisticsViewModel } from '@/presentation/viewmodels/dashboard/languageStatisticsViewModel'
import { StatisticsViewModel } from '@/presentation/viewmodels/dashboard/statisticsViewModel'
import { getBarChartOptions } from '@/util/dashboard/barChartOptions'

export class LanguageStatisticsPresenter {
  private viewModel: LanguageStatisticsViewModel
  private statisticsViewModel: StatisticsViewModel

  constructor(
    statisticsViewModel: StatisticsViewModel,
    viewModel: LanguageStatisticsViewModel = new LanguageStatisticsViewModel()
  ) {
    this.viewModel = viewModel
    this.statisticsViewModel = statisticsViewModel
  }

  get chartData(): ComputedRef<{
    labelChartData: string[]
    languageStatisticsChartData: number[][]
    maxTotal: number
  }> {
    return this.viewModel.chartData
  }

  get chartSeries(): ComputedRef<any[]> {
    return this.viewModel.chartSeries
  }

  get chartOptions(): ComputedRef<any> {
    return this.viewModel.chartOptions
  }

  get isLoading(): ComputedRef<boolean> {
    return this.statisticsViewModel.isLoading
  }

  get error(): ComputedRef<string | null> {
    return this.statisticsViewModel.error
  }

  initChart = (
    userList: User[],
    color: string,
    otherColor: string,
    displayLanguage: DisplayLanguageType,
    isLightMode: boolean
  ) => {
    const chartData = this.getChartOfLanguageStatisticData()

    const chartSeries = []
    for (let i = 0; i < userList.length; i++) {
      chartSeries.push(
        this.getChartData(userList[i].id, chartData.languageStatisticsChartData[i], i == 0 ? color : otherColor)
      )
    }
    const chartOptions = getBarChartOptions(
      displayLanguage == 'Japanese' ? '言語別解答数' : 'Language Statistics',
      color,
      chartData.labelChartData,
      isLightMode
    )
    this.viewModel.setChartData(chartData)
    this.viewModel.setChartSeries(chartSeries)
    this.viewModel.setChartOptions(chartOptions)
  }

  private getChartData = (name: string, values: any, color: string) => {
    return {
      name: name,
      data: values,
      color: color
    }
  }

  // チャート用のデータを取得
  private getChartOfLanguageStatisticData = () => {
    const userStatistics = this.statisticsViewModel.userLanguageStatisticsList.value

    const labelChartData = userStatistics[0].language

    if (labelChartData.length == 0) {
      labelChartData.push('C')
      labelChartData.push('C++')
      labelChartData.push('C++11')
      labelChartData.push('C++14')
      labelChartData.push('JAVA')
      labelChartData.push('C#')
      labelChartData.push('D')
      labelChartData.push('Ruby')
      labelChartData.push('Python')
      labelChartData.push('Python3')
      labelChartData.push('PHP')
      labelChartData.push('JavaScript')
      labelChartData.push('Scala')
      labelChartData.push('Haskell')
      labelChartData.push('OCaml')
      labelChartData.push('Rust')
      labelChartData.push('Go')
      labelChartData.push('Kotlin')
    }

    const languageStatisticsChartData: number[][] = []
    let maxValue = 0

    for (let i = 0; i < userStatistics.length; i++) {
      languageStatisticsChartData.push([])

      for (let j = 0; j < userStatistics[i].language.length; j++) {
        const value = userStatistics[i].value[j] == undefined ? 0 : userStatistics[i].value[j]
        languageStatisticsChartData[i].push(value)

        maxValue = Math.max(maxValue, value)
      }
    }

    return {
      labelChartData,
      languageStatisticsChartData,
      maxTotal: maxValue
    }
  }
}
